<template>
  <v-row>
    <v-col class="col-8">
      <div class="settings-menu">
        <slot>setIcons</slot>
      </div>
    </v-col>
    <v-col class="col-4">
      Project {{ this.$session.get("PROJID") }}<br />
      {{ this.$session.get("PROJTITLE") }}
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    setIcons: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>
<style scoped>
.col-4 {
  padding-bottom: 20px;
}

.settings-menu {
  margin-top: 10px;
  margin-right: 10px;
  color: #55d4ff;
}

.settings-menu svg {
  margin-left: 10px;
  color: #55d4ff;
  font-size: 250%;
  padding-right: 5px;
}

.settings-menu .title {
  margin: 15px;
  font-size: 150%;
}

.settings-menu a {
  margin-left: 10px;
  color: green;
  font-size: 250%;
  padding-right: 5px;
}
</style>
